import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="https://static.readdy.ai/image/e9e586bd4793f176311c78b231428f92/5baa20667f1859ec46821643381a37bc.png"
                alt="Task Zone!"
                className="h-10 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-sm text-gray-400">
              Conectamos a usuarios con los mejores proveedores de servicios domésticos en Aguascalientes, México.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Servicios</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/categories" className="text-sm hover:text-orange-600 transition-colors">
                  Electricidad
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-sm hover:text-orange-600 transition-colors">
                  Limpieza
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-sm hover:text-orange-600 transition-colors">
                  Jardinería
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-sm hover:text-orange-600 transition-colors">
                  Mantenimiento
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4">Empresa</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/sobre-task-zone" className="text-sm hover:text-orange-600 transition-colors">
                  Sobre Task Zone!
                </Link>
              </li>
              <li>
                <Link to="/registro-proveedor" className="text-sm hover:text-orange-600 transition-colors">
                  Ser Proveedor
                </Link>
              </li>
              <li>
                <Link to="/terminos-y-condiciones" className="text-sm hover:text-orange-600 transition-colors">
                  Términos y Condiciones
                </Link>
              </li>
              <li>
                <Link to="/politica-de-privacidad" className="text-sm hover:text-orange-600 transition-colors">
                  Política de Privacidad
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contacto</h3>
            <ul className="space-y-2">
              <li className="text-sm flex items-center space-x-2">
                <i className="ri-mail-line text-orange-600"></i>
                <span>taskzone.app@gmail.com</span>
              </li>
              <li className="text-sm flex items-center space-x-2">
                <i className="ri-phone-line text-orange-600"></i>
                <span>+34 900 123 456</span>
              </li>
              <li className="text-sm flex items-center space-x-2">
                <i className="ri-map-pin-line text-orange-600"></i>
                <span>Aguascalientes, México</span>
              </li>
            </ul>
            <div className="flex space-x-4 mt-4">
              <a href="#" className="text-gray-400 hover:text-orange-600 transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-600 transition-colors">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="https://www.instagram.com/taskzoneapp?igsh=MWEyOGIybDYyem9pZg%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-600 transition-colors">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © 2024 Task Zone!. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
